<template>
  <form
    class="sm-form sm-form__address"
    @submit.prevent="handleSubmit"
  >
    <h4>{{title}}</h4>
    <template v-if="notCurrent">
      <input-text
        v-model="formData.care_of_name"
        :label="'C/O (optional)'"
      />
      <input-text
        v-model="formData.attention"
        :label="'ATTN. (optional)'"
      />
      <phone-input
        v-model="formData.phone"
        :start_val="formData.phone"
        :label="'Phone'"
        :show_errors="true"
        :error_text="errors.first('phone')"
        class="sm-form__address-label"
      />
    </template>
    <country-dropdown
      v-model="selectedCountry"
      :class="'sm-form__address-label'"
      :countryList="countryList"
      :startVal="selectedCountry"
      :error="errors.first('country_id')"
    />
    <input-text
      v-model="formData.street"
      :value="formData.street"
      :label="'Street'"
      :name="'street'"
      v-validate="'required'"
      data-vv-as="Street"
      :error="errors.first('street')"
    />
    <state-dropdown
      v-if="stateList.length > 0"
      v-model="selectedState"
      :class="'sm-form__address-label'"
      :stateList="stateList"
      :startVal="selectedState"
      :error="errors.first('state_id')"
    />
    <input-text
      v-model="formData.city"
      :value="formData.city"
      :label="'City'"
      :name="'city'"
      v-validate="'required'"
      data-vv-as="City"
      :error="errors.first('city')"
    />
    <input-zip
      v-model="formData.zip_code"
      v-validate="'required|is_zip'"
      :country="selectedCountry"
      :error="errors.first('zip_code')"
    />
    <btn-block 
      :text="btnText" 
      type="submit" 
    />
  </form>
</template>

<script>
import InputText from '@/components/InputText';
import InputZip from '@/components/InputZip';
import PhoneInput from '@/components/PhoneInput';
import FormDropdowns from '@/mixins/FormDropdowns';
import CountryDropdown from '@/components/CountryDropdown';
import StateDropdown from '@/components/StateDropdown';

export default {
  name: 'form-address',
  components: {
    'input-text': InputText,
    'input-zip': InputZip,
    'phone-input': PhoneInput,
    'country-dropdown': CountryDropdown,
    'state-dropdown': StateDropdown
  },
  props: {
    title: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      default: 'Submit'
    },
    notCurrent: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: () => new Object()
    },
    account: {
      type: Object,
      default: () => new Object()
    }
  },
  data() {
    return {
      formData: {
        country_id: null,
        state_id: null,
        street: '',
        city: '',
        zip_code: '',
        phone: '',
        attention: '',
        care_of_name: ''
      },
      notCurrentFields: [
        'phone',
        'attention',
        'care_of_name'
      ]
    };
  },
  created() {
    if (Object.keys(this.initData).length) {
      this.mixinUserAccount = this.initData;

      Object.keys(this.formData).forEach(key => {
        if (this.initData[key])
          this.formData[key] = this.initData[key];
      });
    }
  },
  mixins: [FormDropdowns],
  methods: {
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (!valid)
          return;

        if (this.notCurrent && !this.formData.phone) {
          this.errors.add({
            field: 'phone',
            msg: 'Enter phone number'
          });
          return;
        }

        if (!this.formData.country_id) {
          this.errors.add({
            field: 'country_id',
            msg: 'Select country'
          });
          return;
        }

        if (this.stateList.length && !this.formData.state_id) {
          this.errors.add({
            field: 'state_id',
            msg: 'Select state'
          });
          return;
        }
        
        // Actual submit
        let submitData = {};

        Object.keys(this.formData).forEach(key => {
          if (!this.notCurrent && this.notCurrentFields.includes(key))
            return;

          if (key == 'state_id' && !this.stateList.length)
            return;

          submitData[key] = this.formData[key];
        });

        this.$emit('submit', submitData);
      });
    }
  },
  watch: {
    selectedCountry(val) {
      this.formData.country_id = val.id;
    },
    selectedState(val) {
      if (val)
        this.formData.state_id = val.id;
      else
        this.formData.state_id = '';
    },
    formData: {
      deep: true,
      handler() {
        this.errors.clear();
      }
    }
  }
}
</script>
